const footerColumns = [
  {
    title: '围观入口',
    links: [
      { label: '前排热瓜', href: '#front-row' },
      { label: '蹲一个后续', href: '#follow-up' },
      { label: '围观合集索引', href: '#collections' },
      { label: '群众讨论区', href: '#discussion' },
    ],
  },
  {
    title: '蹲守指南',
    links: [
      { label: '如何蹲到后续', href: '#follow-up' },
      { label: '时间线怎么对', href: '#collections' },
      { label: '理性围观守则', href: '#discussion' },
      { label: '订阅更新提醒', href: '#subscribe' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '51.cg 是什么', href: '#top' },
      { label: '内容收录说明', href: '#collections' },
      { label: '纠错与反馈', href: '#subscribe' },
      { label: '使用条款', href: '#top' },
    ],
  },
]

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100/70">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                5
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                51<span className="text-primary-500">.cg</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              51.cg 是吃瓜群众集结、前排围观的群众围观站。群众蹲守的板凳常年备好，蹲一个后续，最新进展随时更新，边看边聊不落空。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-rss-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  aria-label="关注 51.cg 更新"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-secondary-300/70 bg-background-50/70 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="mb-4 font-heading text-sm font-bold text-foreground-950">
                <a href="#top" className="cursor-pointer">
                  {column.title}
                </a>
              </h4>
              <ul className="space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-300/60 pt-6 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 51.cg 群众围观站 · 本站内容均为网友围观与讨论，不代表事实认定，请理性吃瓜。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <a href="#top" className="cursor-pointer hover:text-primary-700">隐私说明</a>
            <a href="#top" className="cursor-pointer hover:text-primary-700">免责声明</a>
            <a href="#top" className="cursor-pointer hover:text-primary-700">内容纠错</a>
          </p>
        </div>
      </div>
    </footer>
  )
}